export default __webpack_public_path__ + "static/media/uv22_en_alph_a2.37cb243e.mp3";